import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModelsListComponent } from './models-list/models-list.component';
import { RequestsListComponent } from './requests-list/requests-list.component';

const routes: Routes = [
  {
    path: 'models',
    children: [
      {
        path: '',
        component: ModelsListComponent,
        data: {
          title: 'Models'
        }
      },
    ]
  },
  {
    path: 'requests',
    children: [
      {
        path: '',
        component: RequestsListComponent,
        data: {
          title: 'Requests'
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentIntelligenceRoutingModule { }
